<template>
  <div class="LoginView">
    <form class="container" @submit.prevent="auth">
      <img class="cross" src="@/assets/cross.svg" alt="" />
      <h1 class="title">Войти в аккаунт</h1>

      <input
        class="container-input"
        v-model="email"
        type="text"
        name="email"
        autocomplete="username"
        placeholder="Логин или электронная почта"
        aria-label="Логин или электронная почта"
      />
      <input
        class="container-input"
        v-model="password"
        type="password"
        name="password"
        autocomplete="current-password"
        placeholder="Пароль"
        aria-label="Пароль"
      />

      <div class="actions">
        <label class="remember">
          <input type="checkbox" name="remember" />
          <span>Запомнить</span>
        </label>
        <button type="submit">Войти</button>
      </div>

      <span class="band"></span>

      <div class="reg">
        <div class="reg-links">
          <span>Забыли пароль?</span>
          <a href="/registration">Зарегистрироваться</a>
        </div>
        <img class="logo" src="@/assets/logo-1.svg" alt="Fox Studio" />
      </div>
    </form>
  </div>
</template>

<script>
import login from "@/composables/views/login.ts";

export default {
  name: "LoginView",
  setup() {
    const { auth, email, password } = login();
    return { auth, email, password };
  },
  components: {},
  computed: {
    count() {
      return this.$store.state.token;
    },
  },
};
</script>
